
import { Vue, Component, Watch } from "vue-property-decorator";
import ConsultationAndCase from "./components/ConsultationAndCase.vue";
import RecentlyActivity from "./components/RecentlyActivity.vue";
import OpenCourse from "./components/OpenCourse.vue";
import ProjectModel from "./components/ProjectModel.vue";
import Business from "@/components/Business.vue";
import Project from "./components/Projects.vue";
import Teacher from "./components/Teachers.vue";
import Student from "./components/Student.vue";
import Question from "./components/Question.vue";
import { formatUpyunUrl } from "@/utils";
import { getCourseList } from "@/apis/about";
// import {openJesongChat} from "easy"
import {
  bannerList,
  courseList,
  studentList,
  questionList,
  teacherList,
  activityList,
  projectInfo
} from "@/apis/home";

@Component({
  components: {
    ConsultationAndCase,
    RecentlyActivity,
    OpenCourse,
    ProjectModel,
    Project,
    Teacher,
    Student,
    Question,
    Business
  }
})
export default class Index extends Vue {

  formatUpyunUrl = formatUpyunUrl;
  // banner
  bList: any = [];
  // FAQ 数据（与 mixins/seo.ts 中首页 FAQ JSON-LD 保持一致）
  activeFaq = 0;
  faqList = [
    {
      question: "光华赋能是一家什么样的公司？",
      answer: "光华赋能（杭州光华赋能教育科技有限公司，原杭州时代光华）由方永飞先生创立于2003年，是一家深耕企业赋能领域23年的专业企业经营研究与服务机构。公司以「用科学经营助推企业高质量发展」为使命，定位为「企业培训咨询陪跑，找光华」，是香港光华管理学院官方授权运营机构。核心理论底座是自主研发的「科学经营™方法论」和「分拆对™工作法」，形成以BLM业务领先模型为内核、BSC平衡计分卡为落地工具的完整经营管理体系。业务覆盖三大核心业务（大增长营、共创会、咨询陪跑）和四大生态业务（光华商学院、光华科研院、光华数字化、企业内训），总部位于杭州市西湖区文一西路522号西溪科创园8幢。"
    },
    {
      question: "光华赋能有多少年行业经验？服务过多少企业？",
      answer: "光华赋能自2003年创立以来，已深耕企业赋能领域23年。截至目前，累计服务各类企业20000余家，累计学员超200万人次，累计面授课堂超3000堂，客户满意度达9.6分，开课准确率98%。在深度合作方面，与300多家企业达成战略合作并共建企业商学院，为100余家准头部或准上市企业开启「企业陪跑计划」并进行上市前管理体系辅导，助推100家企业成功上市。客户覆盖200多个细分行业领域，包括IT互联网、跨境电商、新能源、预制菜、环保、家居、家电、烘焙、自媒体、酒店、母婴、玩具、金融、教育、房地产、生物、医疗等，标杆客户包括阿里巴巴、抖音、百度、腾讯、京东、华为、小米、海尔、TCL等知名企业。"
    },
    {
      question: "光华赋能的核心方法论是什么？",
      answer: "光华赋能的核心方法论是「科学经营™方法论」和「分拆对™工作法」，由董事长方永飞老师经过23年企业经营研究总结提出，是中国企业高质量发展的底座理论与落地工具。科学经营™以BLM业务领先模型为内核，形成「12349」系统应用框架：1个视角（业务视角）、2个飞轮（增长飞轮和效率飞轮）、3个动作（分目标、拆动作、对能力）、4个角度（财务F、客户C、内部流程I、学习与成长L，即BSC平衡计分卡）、9个模块（差距分析、战略意图、市场洞察、创新焦点、人才、关键任务、正式组织、业务设计、氛围与文化），配套18大落地工具和36个关键数据指标。分拆对™工作法核心是「二分二拆二对」，配合「四表二会」确保目标解码到策略行动到落地能力结构性一致。"
    },
    {
      question: "光华赋能和其他培训机构有什么区别？",
      answer: "光华赋能与传统培训机构的核心区别在于「体系化、落地化、长期化」三个维度。第一，光华提供的不是零散课程，而是一套完整的「企业经营底层操作系统」，以科学经营™方法论为统一底座，全公司上下学习同一套语言、同一个方法论，系统性解决「战略与执行断层、个人与组织断层、现在与未来断层」三大核心问题。第二，光华强调「训战结合、落地实效」，采用「学、练、考、评、赛、奖」六环节闭环，课堂上学员亲手使用并带走全套实战工具包（BSC大表、行动方案表、绩效合约表等），咨询陪跑业务更是深度介入企业日常经营，部分服务采用「基础服务费+业绩增量提成」对赌模式。第三，光华是「一站式长期陪跑伙伴」，提供1000+实战专家+高端企业家生态+数字化工具的完整生态，陪伴企业从成长到上市的全周期发展。"
    },
    {
      question: "光华赋能有哪些资质和荣誉？",
      answer: "光华赋能在企业服务领域拥有多项权威资质和荣誉认证：一是浙江省服务「专精特新」企业公共服务示范平台（培训服务、咨询服务方向），这是省级层面针对专精特新企业服务的权威认证；二是省级中小企业公共服务示范平台，代表光华在中小企业公共服务领域的标杆地位；三是第一批浙江省企业管理咨询服务机构，这是浙江省企业管理咨询领域的首批权威准入资质；四是第一批中小企业专业化服务机构，涵盖管理咨询和诊断服务方向、数字化改造方向。此外，创始人方永飞老师是浙江省第一批企业管理现代化对标提升工程专家、国家科技部认证中国火炬创业导师、浙江青年创业导师、阿里巴巴集团特约导师、2025-2026年度西湖文旅宣推官。"
    }
  ];
  // 课程预告,课程类型(1=MBA;2=EMBA)
  courseType = 2;
  cCourseList: any = [];
  blmCourseList: any = [];
  // 活动列表
  aList: any = [];
  // 项目列表
  pList: any = [];
  // 老师列表
  tList: any = [];
  // 学生列表
  sList: any = [];
  // 常见问题
  project_ukey = "emba";
  qList: any = [];
  created() {
    // banner
    this.bannerList();
    // 课程预告
    // this.courseList(true);
    this.courseBlmList(true);
    // 活动列表
    this.activityList();
    // 项目详情
    this.projectInfo();
    // 讲师列表
    this.teacherList();
    // 学生列表
    this.studentList();
    // 光华公开课
    this.openCourseList();
  }
  mounted() {
    // meta 标签和 JSON-LD 已通过 vue-meta 的 metaInfo 统一管理
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
  // bannerList
  async bannerList() {
    // const { data } = await bannerList({
    //   client: 1
    // });
    // this.bList = data;
    console.log(123456);
    // /img/5aaaf9ba1e0327f2171684e58c740afa.png
    // /img/0e18355a8e0db6e4f72485870a7e967d.png
    // /img/1068c07964209b0d2f93e6e648e903ec.png
    this.bList.push({
      img: "https://hangfubao.eweixue.com/img/1.png"
    });
    this.bList.push({
      img: "https://hangfubao.eweixue.com/img/2.png"
    });
    this.bList.push({
      img: "https://hangfubao.eweixue.com/img/3.png"
    });

    // for (let index = 1; index <= 3; index++) {
    //   this.bList.push({
    //     img: require("@/assets/banner" + index + ".png")
    //   });
    // }

    console.log("this.bList", this.bList);
  }

  toUrl(index: any) {
    if (index == 0) {
      this.$router.push("/academy");
    } else if (index == 1) {
      this.$router.push("/accompany?tab=0");
    } else if (index == 2) {
      this.$router.push("/research-institute");
    }
  }
  // FAQ 展开/收起
  toggleFaq(index: number) {
    this.activeFaq = this.activeFaq === index ? -1 : index;
  }
  // 课程预告
  async courseList(auto: any) {
    const { data } = await courseList({
      f: this.courseType,
      per_page: 4,
      page: 1
    });
    //如果emba没数据默认mba
    if ((!data || data.length == 0) && this.courseType == 2 && auto) {
      this.courseType = 1;
      this.courseList(false);
      return;
    }
    this.cCourseList = data;
    if (this.courseType == 2 || this.courseType == 1) {
      if (this.cCourseList.length == 1 || this.cCourseList.length == 3) {
        this.cCourseList.push({
          origin_id: "",
          empty: "1"
        });
      }
    } else if (this.courseType == 3) {
      if (this.cCourseList && this.cCourseList.length > 1) {
        this.cCourseList = data.slice(0, 1);
      }
    }
  }

  // blm课程预告,没有要把tab隐藏
  async courseBlmList(auto: any) {
    const { data } = await courseList({
      f: 3,
      per_page: 4,
      page: 1
    });
    //如果emba没数据默认mba

    if (data && data.length > 1) {
      this.blmCourseList = data.slice(0, 1);
    } else {
      this.blmCourseList = data || [];
    }
  }

  // 活动列表
  async activityList() {
    const { data } = await activityList({
      per_page: 4,
      page: 1
    });
    data.map((item: any, index: any) => {
      item.select = index == 0;
    });
    this.aList = data;
  }
  // 项目列表
  async projectInfo() {
    const data = await projectInfo({
      ukey: "emba"
    });
    this.pList.push(data);
    const data1 = await projectInfo({
      ukey: "mba"
    });
    this.pList.push(data1);
    const data2 = await projectInfo({
      ukey: "blm"
    });
    this.pList.push(data2);
  }
  // 老师列表
  async teacherList() {
    const { data } = await teacherList({
      per_page: 5,
      page: 1
    });
    this.tList = data;
  }
  // 学生列表
  async studentList() {
    let { data } = await studentList({
      per_page: 45,
      page: 1
    });

    // 9个分为一组，总共几组
    let total = Math.ceil(data.length / 9.0);
    this.sList = [];
    for (let index = 0; index < total; index++) {
      this.sList.push(
        data.slice(
          index * 9,
          data.length >= index * 9 + 9 ? index * 9 + 9 : index * 9 + 9
        )
      );
    }

    // console.log(this.sList);
    // this.sList = data;
  }
  // 公开课列表
  async openCourseList() {
    const { data } = await getCourseList({
      project_ukey: this.project_ukey,
      per_page: 4,
      page: 1
    });
    this.qList = data;
  }
  // 切换问题类型
  // changeUkey(ukey: any) {
  //   this.project_ukey = ukey;
  //   this.questionList();
  // }
  // 切换课程预告类型
  // changeCourse(f: any) {
  //   this.courseType = f;
  //   if (this.courseType == 1 || this.courseType == 2) {
  //     this.courseList(false);
  //   }
  // }
}
